import { Guid } from "guid-typescript";

export class Arquivo {
    id: Guid;
    pasta: String;
    nome: String;
    contentType: String;
}
